import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { FotoWareSettings } from "../../Model/fotoWare/fotoWareSettings";
import { Mime } from "../../Model/Catalog/Mime";
import { LoginService } from "../login.service";

export interface FotoWareStoreLinkResult {
  handled: boolean;
  success?: boolean;
  message?: string;
  mime?: Mime;
}

@Injectable()
export class FotoWareSettingsService {
  constructor(private loginService: LoginService, private http: HttpClient) {
  }

  public get(): Observable<FotoWareSettings> {
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
      params: new HttpParams().append("customerId", this.loginService.currentCustomer.id)
    }
    return this.http.get<FotoWareSettings>("api/FotoWareSettings/Get", options);
  }

  public update(settings: FotoWareSettings): Observable<FotoWareSettings> {
    settings.customerId = this.loginService.currentCustomer.id;
    return this.http.post<FotoWareSettings>("api/FotoWareSettings/Update", settings);
  }

  public testConnection(): Observable<{ success: boolean, message: string }> {
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
      params: new HttpParams().append("customerId", this.loginService.currentCustomer.id)
    }
    return this.http.get<{ success: boolean, message: string }>("api/FotoWareSettings/TestConnection", options);
  }

  public storeLink(productId: string, mime: Mime): Observable<FotoWareStoreLinkResult> {
    const options = {
      params: new HttpParams().append("customerId", this.loginService.currentCustomer.id).append("productId", productId)
    }
    return this.http.post<FotoWareStoreLinkResult>("api/FotoWareSettings/StoreLink", mime, options);
  }
}
